import React from 'react'
import Navbar from '../../components/Navbar'
import SmallFooter from '../../components/SmallFooter'

const Team = [
    { 'name': 'Person 1', 'role': 'Frontend Developer', 'img': 'https://avatars.githubusercontent.com/u/565665659', 'github': 'https://github.com' },
    { 'name': 'Person 2', 'role': 'Content Writing & Testing', 'img': 'https://avatars.githubusercontent.com/u/565665659', 'github': 'https://github.com' },
    { 'name': 'Person 3', 'role': 'Backend Developer', 'img': 'https://avatars.githubusercontent.com/u/565665659', 'github': 'https://github.com' },
    { 'name': 'Rakesh 4', 'role': 'Backend Developer', 'img': 'https://avatars.githubusercontent.com/u/565665659', 'github': 'https://github.com' },
    { 'name': 'Person 5', 'role': 'Backend Developer', 'img': 'https://avatars.githubusercontent.com/u/565665659', 'github': 'https://github.com' },
    { 'name': 'Person 6', 'role': 'Frontend Developer', 'img': 'https://avatars.githubusercontent.com/u/565665659', 'github': 'https://github.com' },
    { 'name': 'Person 7', 'role': 'PR, Data Entry & Testing', 'img': 'https://avatars.githubusercontent.com/u/565665659', 'github': 'https://github.com' },
]

const AboutUs = () => {
    return (
        <div className='dark:text-white dark:bg-black'>
            <Navbar />
            <section className="text-gray-600 body-font relative dark:text-white">
                <div className="container px-5 py-24 mx-auto">
                    <div className="flex flex-col text-center w-full mb-20">
                        <h1 className="sm:text-3xl text-2xl font-medium title-font mb-4 dark:text-white text-gray-900">Our Team</h1>
                        <p className="lg:w-2/3 mx-auto leading-relaxed text-base">Indeed, we have won championships by gaining several brands’ trust. Our workforce consists of young, talented geniuses who bring their experience and expertise to our company and help its constant growth. We believe in working hard, having fun and creating no drama!
                        </p>
                    </div>
                    <div className="flex flex-wrap -m-2">
                        {Team.map((item, index) =>
                        (
                            <a key={index} className="p-2 lg:w-1/3 md:w-1/2 w-full group cursor-pointer" target="_blank" href={item.github} rel="noreferrer">
                                <div className="h-full flex items-center border-gray-200 border p-4 rounded-lg group-hover:bg-gray-100 dark:group-hover:bg-gray-900">
                                    <img alt="team" className="w-16 h-16 bg-gray-100 object-cover object-center flex-shrink-0 rounded-full mr-4" src={item.img} />
                                    <div className="flex-grow">
                                        <h2 className="text-gray-900 title-font font-medium dark:text-white">{item.name}</h2>
                                        <p className="text-gray-500 dark:text-gray-400">{item.role}</p>
                                    </div>
                                </div>
                            </a>
                        )
                        )}
                    </div>
                </div>
            </section>
            <SmallFooter />
        </div>
    )
}

export default AboutUs